import { AppActionTypes, SubscribeSuccessPayload } from 'store/app/actions/types'

export const SUBSCRIBE_START = 'APP/SUBSCRIBE_START'
export const SUBSCRIBE_SUCCESS = 'APP/SUBSCRIBE_SUCCESS'
export const SUBSCRIBE_ERROR = 'APP/SUBSCRIBE_ERROR'

export const subscribeStart = (): AppActionTypes => {
  return { type: SUBSCRIBE_START }
}

export const subscribeSuccess = ({ opportunityId }: SubscribeSuccessPayload): AppActionTypes => {
  return { type: SUBSCRIBE_SUCCESS, opportunityId }
}

export const subscribeError = (): AppActionTypes => {
  return { type: SUBSCRIBE_ERROR }
}
